import React, { FunctionComponent, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../../store";
import { asList, useLoadIfEmpty } from "../../../hooks/useLoadIfEmpty";
import { thunkFetchSegments } from "../../../store/segments/actions";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { Segment } from "../../../models/Segment";

interface SegmentSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
  onSelected: (item: Segment) => void;
}

export const SegmentSelect: FunctionComponent<SegmentSelectProps> = ({
  label = "Segment",
  required = false,
  disabled = false,
  onSelected,
  onChange,
  variant = "standard",
  value = "",
  error = false,
  ...props
}) => {
  const [state, setState] = useState<ReadonlyArray<Segment>>([]);
  const segments = asList<Segment>(
    useSelector<AppState, unknown>(s => s.segments)
  );

  useLoadIfEmpty(!segments.length, thunkFetchSegments);

  useEffect(() => {
    let filtered = segments?.length > 0 && segments;

    if (filtered) {
      setState(
        filtered.slice().sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        })
      );
    }
  }, [segments]);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let item = state.find(i => i.id === event.target.value);
      if (item) {
        onSelected(item);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  return (
    <FormControl
      variant={variant}
      className={props.className}
      error={error}
      required={required}
      disabled={disabled}
    >
      <InputLabel
        id="segment-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="segment-select-label"
        id="segment-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(x => (
            <MenuItem key={x.id} value={x.id}>
              {x.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
